import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuAccordionTemplate]',
})
export class MuAccordionTemplateDirective {
  @Input('appMuAccordionTemplate') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
